import { RevokeApiTokenCommand } from '../commands/revoke-api-token.command';
import { RevokeApiTokenContent } from '../commands/payloads/revoke-api-token-content';
import type { CommandResultBus } from './command-result-bus.interface';

/** What a revocation did: revoked, or refused by the server (a dispatch that throws included). */
export type OwnApiTokenRevokeOutcome =
    | { kind: 'revoked' }
    | { kind: 'refused'; error: unknown };

/** Revokes one of the user's own API tokens: sends `revoke.api-token` for the own uid. */
export async function revokeOwnApiToken(userUid: string, tokenUid: string, bus: CommandResultBus): Promise<OwnApiTokenRevokeOutcome> {
    try {
        const result = await bus.dispatchCommandForResult(new RevokeApiTokenCommand(userUid, new RevokeApiTokenContent(tokenUid)));

        return result.success ? { kind: 'revoked' } : { kind: 'refused', error: result.error };
    } catch (error) {
        return { kind: 'refused', error };
    }
}
